///<reference path="../../employee/sections/employee.deduction.section.ts"/>
module Meevo.Plugins.Student {
  "use strict";

  /**
  * Deduction Section of Employee 
  */
  export class DeductionSection extends Meevo.Plugins.Employee.DeductionSection {
      public get auditNounForSave() {
          return Model.NounEnum.StudentDeduction;
      }
  }
}